export default __webpack_public_path__ + "static/huawei_gallery_badge_tc-a1fb6e1eff7319b85bc347b59633a238.svg";